import { getCseData, isCSE } from "@/utils/cse"
import type { Locale } from "@/service/translate/flights/flightTranslations.types"

const CSE_NL_WEBSITE = 'www.nl.travelski.com'

function getLegalDocHost(): string {
    const host = process.env.VUE_APP_WEBSITE || (window.location.hostname == 'localhost' ? 'www.travelski.com' : window.location.hostname)
    const locale = window.locale as Locale
    if (locale && isCSE(locale) && getCseData(locale)?.companyLang === 'nl') {
        return CSE_NL_WEBSITE
    }
    return host
}

export function getLegalDocUrl(prestid: string | number): string {
    if (typeof window === "undefined" || !window.location?.hostname) {
        throw new Error("window.location.hostname is unavailable")
    }

    return `https://docs.travelski.com/legal-docs/${getLegalDocHost()}/${prestid}/index.pdf`
}
